<template lang="html">
  <div class="">
    <StartupInfoLine v-if="candidate.company_type" name="Company type" :value="candidate.company_type" />
    <StartupInfoLine v-else name="Company type" value="No data" />

    <StartupInfoLine v-if="candidate.application_area" name="Application domain" :value="candidate.application_area" :isArray="Array.isArray(candidate.application_area)" />
    <StartupInfoLine v-else name="Application domain" value="No data" />

    <StartupInfoLine v-if="candidate.value_proposition" name="Value proposition" :value="candidate.value_proposition"  :isArray="Array.isArray(candidate.value_proposition)"/>
    <StartupInfoLine v-else name="Value proposition" value="No data" />

    <StartupInfoLine v-if="candidate.solution" name="Solution" :value="candidate.solution" :isArray="Array.isArray(candidate.solution)" />
    <StartupInfoLine v-else name="Solution" value="No data" />

    <StartupInfoLine v-if="candidate.location" name="Location" :value="candidate.location" :isLocation="true" :isArray="Array.isArray(candidate.location)"/>
    <StartupInfoLine v-else name="Location" value="No data" />

    <StartupInfoLine v-if="isAdmin && candidate.startup_access" name="Innovator access" isUrl="true" :value="'https://partnerplus.innopearl.ch/manage_startup_info/'+candidate.startup_access.$oid" />

 </div>
</template>


<script>
 import StartupInfoLine from '@/components/InfoStartupLine.vue'

export default {
  name : "NonStartupCardInner",
  props: ["candidate","isAdmin"],
  components: {
    StartupInfoLine,
  },

}
</script>
